/**
 * MonitoredProductsTab Component
 *
 * Wrapper component for the Monitored Products tab content.
 */

import React from 'react';

import { MonitoredProductsTabContent } from '../index';
import {
  useMonitoringShared,
  useMonitoringSearch,
  useMonitoringActionsMenu,
  useMonitoringProductsTab,
} from '../../../contexts/MonitoringCenterContext';

/**
 * Monitored Products tab content wrapper
 */
export function MonitoredProductsTab() {
  const shared = useMonitoringShared();
  const search = useMonitoringSearch();
  const actionsMenu = useMonitoringActionsMenu();
  const productsTab = useMonitoringProductsTab();

  return (
    <MonitoredProductsTabContent
      filteredProducts={productsTab.filteredProducts}
      searchQuery={search.searchQuery}
      onboardingData={productsTab.onboardingData}
      shopDomain={productsTab.shopDomain}
      onProductClick={productsTab.onProductClick}
      hasTestData={shared.hasTestData}
      currentPage={productsTab.currentPage}
      totalPages={productsTab.totalPages}
      itemsPerPage={productsTab.itemsPerPage}
      onPageChange={productsTab.onPageChange}
      onOpenWizard={actionsMenu.onOpenWizard}
    />
  );
}
